var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5442 16.8749C17.9851 15.6218 18.8551 14.5651 20.0004 13.8921C21.1457 13.219 22.4922 12.9729 23.8014 13.1975C25.1107 13.4221 26.2983 14.1028 27.1538 15.1191C28.0092 16.1353 28.4775 17.4215 28.4755 18.7499C28.4755 22.4999 22.8505 24.3749 22.8505 24.3749M23.0005 31.8749H23.0192M41.7505 22.4999C41.7505 32.8553 33.3558 41.2499 23.0005 41.2499C12.6451 41.2499 4.25049 32.8553 4.25049 22.4999C4.25049 12.1446 12.6451 3.74994 23.0005 3.74994C33.3558 3.74994 41.7505 12.1446 41.7505 22.4999Z",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.cddf94d04d31441afaa5a6244e8a58f2.svg";
export { ForwardRef as ReactComponent };